module.exports = __webpack_public_path__ + "img/catholic-super-illustration-library_grow-money.2c269c4c.svg";